export type Strength = { score: 0 | 1 | 2 | 3; label: string };

/** Indicador simples (não substitui a política do contrato): comprimento e variedade de caracteres. */
export function passwordStrength(pw: string): Strength {
  if (!pw) return { score: 0, label: '' };
  if (pw.length < 8) return { score: 1, label: 'Fraca' };
  let points = 0;
  if (pw.length >= 12) points++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) points++;
  if (/\d/.test(pw) && /[A-Za-z]/.test(pw)) points++;
  if (/[^A-Za-z0-9]/.test(pw)) points++;
  if (points <= 1) return { score: 1, label: 'Fraca' };
  if (points === 2) return { score: 2, label: 'Média' };
  return { score: 3, label: 'Forte' };
}
